<template>
  <div class="min-h-screen bg-gray-50">
    <!-- 页面标题 -->
    <div class="bg-white shadow-sm border-b">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between h-16">
          <div>
            <h1 class="text-2xl font-bold text-gray-900">{{ $store.getters.t('operation_workbench') }}</h1>
            <p class="text-sm text-gray-600">{{ $store.getters.t('operation_workbench_desc') }}</p>
          </div>
          <div class="flex items-center space-x-4">
            <div class="flex items-center space-x-2">
              <div class="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
              <span class="text-sm text-gray-600">{{ $store.getters.t('operation_workbench_running') }}</span>
            </div>
            <button class="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors">
              <i class="fas fa-plus mr-2"></i>
              {{ $store.getters.t('new_operation_task') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <!-- 运营概览卡片 -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">{{ $store.getters.t('operation_task') }}</p>
              <p class="text-2xl font-bold text-gray-900">89</p>
            </div>
            <div class="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-tasks text-green-600 text-xl"></i>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">+15% 本周</span>
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">{{ $store.getters.t('training_completion') }}</p>
              <p class="text-2xl font-bold text-gray-900">156</p>
            </div>
            <div class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-graduation-cap text-blue-600 text-xl"></i>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-xs text-blue-600 bg-blue-100 px-2 py-1 rounded-full">92% 完成率</span>
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">{{ $store.getters.t('auto_follow') }}</p>
              <p class="text-2xl font-bold text-gray-900">234</p>
            </div>
            <div class="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-robot text-purple-600 text-xl"></i>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-xs text-purple-600 bg-purple-100 px-2 py-1 rounded-full">AI驱动</span>
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">{{ $store.getters.t('revenue_growth') }}</p>
              <p class="text-2xl font-bold text-gray-900">+23%</p>
            </div>
            <div class="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-chart-line text-yellow-600 text-xl"></i>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-xs text-yellow-600 bg-yellow-100 px-2 py-1 rounded-full">本月</span>
          </div>
        </div>
      </div>

      <!-- 主要功能区域 -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <!-- 开播前准备 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-cog mr-2 text-green-500"></i>
              {{ $store.getters.t('preparation_before_broadcast') }}
            </h3>
            <span class="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">进行中</span>
          </div>
          <div class="space-y-4">
            <div class="p-4 bg-green-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('equipment_check') }}</span>
                <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">已完成</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('equipment_check_desc') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('completion_time') }}: 1小时前</div>
            </div>
            <div class="p-4 bg-green-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('scene_arrangement') }}</span>
                <span class="text-xs bg-yellow-200 text-yellow-800 px-2 py-1 rounded">进行中</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('scene_arrangement_desc') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('estimated_completion') }}: 15分钟</div>
            </div>
            <div class="p-4 bg-green-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('content_planning') }}</span>
                <span class="text-xs bg-gray-200 text-gray-800 px-2 py-1 rounded">待开始</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('content_planning_desc') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('planned_time') }}: 30分钟后</div>
            </div>
          </div>
        </div>

        <!-- 创作者培训 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-user-graduate mr-2 text-blue-500"></i>
              {{ $store.getters.t('creator_training') }}
            </h3>
            <button class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full hover:bg-blue-200">
              <i class="fas fa-plus mr-1"></i>
              {{ $store.getters.t('new_training') }}
            </button>
          </div>
          <div class="space-y-4">
            <div class="p-4 bg-blue-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('skill_training') }}</span>
                <span class="text-xs bg-blue-200 text-blue-800 px-2 py-1 rounded">进行中</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('skill_training_desc') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('participant_count') }}: 23人</div>
            </div>
            <div class="p-4 bg-blue-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('platform_rules') }}</span>
                <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">已完成</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('platform_rules_desc') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('completed_count') }}: 45人</div>
            </div>
            <div class="p-4 bg-blue-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('data_analysis') }}</span>
                <span class="text-xs bg-gray-200 text-gray-800 px-2 py-1 rounded">待开始</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('data_analysis_desc') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('planned_time') }}: 明天</div>
            </div>
          </div>
        </div>

        <!-- 自动跟播 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-robot mr-2 text-purple-500"></i>
              {{ $store.getters.t('auto_follow') }}
            </h3>
            <span class="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded-full">AI驱动</span>
          </div>
          <div class="space-y-4">
            <div class="p-4 bg-purple-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('hot_topics') }}</span>
                <span class="text-xs bg-purple-200 text-purple-800 px-2 py-1 rounded">跟踪中</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('hot_topics_desc') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('tracking_topics') }}: 12个</div>
            </div>
            <div class="p-4 bg-purple-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('competitor_analysis') }}</span>
                <span class="text-xs bg-purple-200 text-purple-800 px-2 py-1 rounded">分析中</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('competitor_analysis_desc') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('analysis_objects') }}: 8个</div>
            </div>
            <div class="p-4 bg-purple-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('content_recommendation') }}</span>
                <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">推荐中</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('content_recommendation_desc') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('recommended_content') }}: 25个</div>
            </div>
          </div>
        </div>

        <!-- 复盘分析 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-chart-bar mr-2 text-yellow-500"></i>
              {{ $store.getters.t('post_mortem_analysis') }}
            </h3>
            <span class="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">深度分析</span>
          </div>
          <div class="space-y-4">
            <div class="p-4 bg-yellow-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('data_post_mortem') }}</span>
                <span class="text-xs bg-yellow-200 text-yellow-800 px-2 py-1 rounded">分析中</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('data_post_mortem_desc') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('analysis_sessions') }}: 15场</div>
            </div>
            <div class="p-4 bg-yellow-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('problem_identification') }}</span>
                <span class="text-xs bg-red-200 text-red-800 px-2 py-1 rounded">发现问题</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('problem_identification_desc') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('identified_problems') }}: 8个</div>
            </div>
            <div class="p-4 bg-yellow-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('optimization_suggestions') }}</span>
                <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">已生成</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('optimization_suggestions_desc') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('suggestion_count') }}: 12条</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 运营任务列表 -->
      <div class="bg-white rounded-lg shadow-sm border p-6 mt-8">
        <div class="flex items-center justify-between mb-6">
          <h3 class="text-lg font-semibold text-gray-900">{{ $store.getters.t('operation_task_management') }}</h3>
          <div class="flex space-x-2">
            <select class="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-green-500">
              <option>{{ $store.getters.t('all_status') }}</option>
              <option>{{ $store.getters.t('in_progress') }}</option>
              <option>{{ $store.getters.t('completed') }}</option>
              <option>{{ $store.getters.t('pending_start') }}</option>
            </select>
            <button class="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors text-sm">
              <i class="fas fa-filter mr-1"></i>
              {{ $store.getters.t('filter') }}
            </button>
          </div>
        </div>
        
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $store.getters.t('task_name') }}</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $store.getters.t('task_type') }}</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $store.getters.t('task_status') }}</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $store.getters.t('task_progress') }}</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $store.getters.t('task_actions') }}</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div>
                    <div class="text-sm font-medium text-gray-900">{{ $store.getters.t('new_creator_training_plan') }}</div>
                    <div class="text-sm text-gray-500">{{ $store.getters.t('train_new_creators') }}</div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                    {{ $store.getters.t('training_task') }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                    {{ $store.getters.t('in_progress') }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <div class="w-16 bg-gray-200 rounded-full h-2 mr-2">
                      <div class="bg-green-600 h-2 rounded-full" style="width: 75%"></div>
                    </div>
                    <span class="text-sm text-gray-900">75%</span>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button class="text-blue-600 hover:text-blue-900 mr-3">{{ $store.getters.t('view') }}</button>
                  <button class="text-green-600 hover:text-green-900">{{ $store.getters.t('edit') }}</button>
                </td>
              </tr>
              <tr>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div>
                    <div class="text-sm font-medium text-gray-900">{{ $store.getters.t('hot_topic_follow') }}</div>
                    <div class="text-sm text-gray-500">{{ $store.getters.t('follow_hot_topics_and_create_content') }}</div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-purple-100 text-purple-800">
                    {{ $store.getters.t('follow_task') }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">
                    {{ $store.getters.t('pending_start') }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <div class="w-16 bg-gray-200 rounded-full h-2 mr-2">
                      <div class="bg-yellow-600 h-2 rounded-full" style="width: 0%"></div>
                    </div>
                    <span class="text-sm text-gray-900">0%</span>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button class="text-blue-600 hover:text-blue-900 mr-3">{{ $store.getters.t('view') }}</button>
                  <button class="text-green-600 hover:text-green-900">{{ $store.getters.t('start') }}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OperationWorkbench',
  data() {
    return {
      // 可以添加数据
    }
  },
  methods: {
    // 可以添加方法
  }
}
</script>

<style scoped>
/* 可以添加样式 */
</style> 